// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3qrSr","detailsBorder":"styles_detailsBorder__D4JG_"};